/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import parameters from './__generated__/JiraSoftwareFormBuilderAppQuery$parameters';
import type { JiraSoftwareFormBuilderAppQuery } from './__generated__/JiraSoftwareFormBuilderAppQuery.graphql';

type FormBuilderEntrypointComponent = EntryPointComponent<
	{
		formBuilderQuery: JiraSoftwareFormBuilderAppQuery;
	},
	{},
	{},
	{}
>;

export const formBuilderEntrypoint: EntryPoint<
	FormBuilderEntrypointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForUserVisible<FormBuilderEntrypointComponent>(
		/* webpackChunkName: "async-software-form-builder-entrypoint" */ './JiraSoftwareFormBuilderApp.tsx',
		{
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: ({ context, tenantContext: { cloudId } }: EntryPointRouteParams) => {
		const projectKey = context.match.params.projectKey;

		if (projectKey == null) {
			throw new Error('Project key missing');
		}

		return {
			queries: {
				formBuilderQuery: {
					options: {
						fetchPolicy: 'store-and-network' as const,
					},
					parameters,
					variables: {
						cloudId,
						projectKey,
					},
				},
			},
		};
	},
});
